/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_EssentialInputs */

const en_cookie_consent_essential = /** @type {(inputs: Cookie_Consent_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essential`)
};

const de_cookie_consent_essential = /** @type {(inputs: Cookie_Consent_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notwendig`)
};

const fr_cookie_consent_essential = /** @type {(inputs: Cookie_Consent_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essentiels`)
};

const es_cookie_consent_essential = /** @type {(inputs: Cookie_Consent_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esenciales`)
};

const it_cookie_consent_essential = /** @type {(inputs: Cookie_Consent_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essenziali`)
};

const nl_cookie_consent_essential = /** @type {(inputs: Cookie_Consent_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essentieel`)
};

const pl_cookie_consent_essential = /** @type {(inputs: Cookie_Consent_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niezbedne`)
};

const fi_cookie_consent_essential = /** @type {(inputs: Cookie_Consent_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välttämättömät`)
};

const da_cookie_consent_essential = /** @type {(inputs: Cookie_Consent_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadvendige`)
};

const sv_cookie_consent_essential = /** @type {(inputs: Cookie_Consent_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodvandiga`)
};

/**
* | output |
* | --- |
* | "Essential" |
*
* @param {Cookie_Consent_EssentialInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_essential = /** @type {((inputs?: Cookie_Consent_EssentialInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_EssentialInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_essential(inputs)
	if (locale === "fr") return fr_cookie_consent_essential(inputs)
	if (locale === "es") return es_cookie_consent_essential(inputs)
	if (locale === "it") return it_cookie_consent_essential(inputs)
	if (locale === "nl") return nl_cookie_consent_essential(inputs)
	if (locale === "pl") return pl_cookie_consent_essential(inputs)
	if (locale === "fi") return fi_cookie_consent_essential(inputs)
	if (locale === "da") return da_cookie_consent_essential(inputs)
	if (locale === "sv") return sv_cookie_consent_essential(inputs)
	return en_cookie_consent_essential(inputs)
});